export const SPECIAL_CHARACTERS = {
    "a": "áàâäãåāăą",
    "c": "çćč",
    "d": "ďđ",
    "e": "éèêëēĕėęě",
    "g": "ğĝġģ",
    "h": "ĥħ",
    "i": "íìîïĩīĭįı",
    "j": "ĵ",
    "k": "ķ",
    "l": "ĺļľŀł",
    "n": "ñńņňŉŋ",
    "o": "óòôöõōŏő",
    "r": "ŕŗř",
    "s": "śŝşš",
    "t": "ţťŧ",
    "u": "úùûüũūŭůűų",
    "w": "ŵ",
    "y": "ýÿŷ",
    "z": "źżž",
};
export const DE = [
    [
        { lowercase: "^", uppercase: "°" }, { lowercase: "1", uppercase: "!" }, { lowercase: "2", uppercase: "\"" }, { lowercase: "3", uppercase: "§" },
        { lowercase: "4", uppercase: "$" }, { lowercase: "5", uppercase: "%" }, { lowercase: "6", uppercase: "&" },
        { lowercase: "7", uppercase: "/" }, { lowercase: "8", uppercase: "(" }, { lowercase: "9", uppercase: ")" },
        { lowercase: "0", uppercase: "=" }, { lowercase: "ß", uppercase: "?" }, { lowercase: "´", uppercase: "`" }
    ],
    [...'qwertzuiopü'.split(''), { lowercase: "+", uppercase: "*" }],
    [...'asdfghjklöä'.split(''), { lowercase: "#", uppercase: "'" }],
    [
        { lowercase: "<", uppercase: ">" }, ...'yxcvbnm'.split(''),
        { lowercase: ",", uppercase: ";" }, { lowercase: ".", uppercase: ":" }, { lowercase: "-", uppercase: "_" }
    ]
];
export const DE_SPECIAL_CHARACTERS = /ä|ö|ü|ß/;
export const US = [
    '§1234567890-='.split(''),
    'qwertyuiop[]'.split(''),
    'asdfghjkl;\'\\'.split(''),
    '`zxcvbnm,./'.split('')
];
export const EN = US;
export const UK = US;
export const NL = US;
export const FR = [
    '#1234567890°-'.split(''),
    'àâçèéêëîïôùûüÿ'.split(''),
    'azertyuiop'.split(''),
    'qsdfghjklm'.split(''),
    '<wxcvbn,;:'.split('')
];
export const FR_SPECIAL_CHARACTERS = /à|â|ç|è|é|ê|ë|î|ï|ô|ù|û|ü|ÿ/;
export const CR = [
    '"1234567890/+'.split(''),
    'qwertyuiopšđ'.split(''),
    'asdfghjkl;čćž\''.split(''),
    '<zxcvbnm,./'.split('')
];
export const CR_SPECIAL_CHARACTERS = /š|đ|č|ć|ž/;
export const TR = [
    '"1234567890*-'.split(''),
    'qwertyuiopğü'.split(''),
    'asdfghjklşi̇,'.split(''),
    '<zxcvbnmöç.'.split('')
];
export const TR_SPECIAL_CHARACTERS = /ğ|ü|ş|i̇|ö|ç/;
export const ES = [
    '1234567890\'¡'.split(''),
    'qwertyuiop`+'.split(''),
    'asdfghjklñ´ç,'.split(''),
    '<zxcvbnm,.-'.split('')
];
export const ES_SPECIAL_CHARACTERS = /ç/;
export const PT = [
    '§1234567890\'+'.split(''),
    'qwertyuiop´'.split(''),
    'asdfghjklç~\\,'.split(''),
    '<zxcvbnm,.-'.split('')
];
export const PT_SPECIAL_CHARACTERS = /ç/;
export const PHONE = [
    "123".split(""),
    "456".split(""),
    "789".split(""),
    "*0+".split("")
];
export const NUMBER = [
    "123".split(""),
    "456".split(""),
    "789".split(""),
    "0.,".split("")
];
export const availableLanguageLayouts = { DE, US, EN, FR, UK, NL, CR, TR, ES, PT };
export const availableSpecialCharacters = { DE: DE_SPECIAL_CHARACTERS, FR: FR_SPECIAL_CHARACTERS, CR: CR_SPECIAL_CHARACTERS, TR: TR_SPECIAL_CHARACTERS, ES: ES_SPECIAL_CHARACTERS, PT: PT_SPECIAL_CHARACTERS };
export const getKeyboardLayoutFromLayoutType = (type, language, additionalRegex) => {
    if (!language) {
        language = "US";
    }
    else {
        language = language.toUpperCase();
    }
    if (!availableLanguageLayouts[language]) {
        console.log(`Language ${language} not supported, using US layout instead`);
        language = "US";
    }
    const filterByRegex = (layout, ...regs) => {
        const regExpressions = regs.filter(reg => reg);
        if (!language)
            return [];
        if (regExpressions.length === 0)
            return layout;
        let newLayout = layout.map(row => row.filter(key => regExpressions.some(regex => (typeof key === "string" ? regex?.test(key) : (regex?.test(key.lowercase) || regex?.test(key.uppercase))))))
            .map(row => row.map(key => {
            if (typeof key === "string") {
                return key;
            }
            else {
                if (regExpressions.some(regex => regex?.test(key.lowercase) && regex?.test(key.uppercase))) {
                    return key;
                }
                else if (regExpressions.some(regex => regex?.test(key.lowercase))) {
                    return key.lowercase;
                }
                else {
                    return key.uppercase;
                }
            }
        }));
        const rowsWithFewMembers = newLayout.filter(r => r.length <= 2 && r.length > 0);
        if (rowsWithFewMembers.length > 0) {
            newLayout = newLayout.filter(r => r.length > 2);
            rowsWithFewMembers.forEach(r => {
                const row = newLayout.find(r2 => r2.length > 2);
                if (row) {
                    row.push(r[0]);
                }
            });
        }
        return newLayout;
    };
    switch (type) {
        case "plaintext":
            return filterByRegex(availableLanguageLayouts[language], additionalRegex, /^[a-zA-Z]$/, availableSpecialCharacters[language]);
        case "text":
            return filterByRegex(availableLanguageLayouts[language], additionalRegex, /^[a-zA-Z]$/, availableSpecialCharacters[language]);
        case "email":
            return filterByRegex(availableLanguageLayouts[language], additionalRegex, /^[a-zA-Z]|\.|-|_$/);
        case "number":
            return NUMBER;
        case "tel":
            return PHONE;
        case "url":
            return filterByRegex(availableLanguageLayouts[language], /^[a-zA-Z]|\.|-|_$/, additionalRegex);
        default:
            return filterByRegex(availableLanguageLayouts[language], additionalRegex);
    }
};
